import { ScenarioUpdate } from '../types';

const PHASE_PRIORITY: Record<string, number> = { committed: 2, reverted: 1, ran: 0 };

// One Siesta turn can emit several updates for the same scenario (create, then
// seed commit, then projection run). A card per update reads as three separate
// operations, so keep one card per scenario: the earliest update with the most
// significant phase (commit > revert > projection run).
export function mergeScenarioUpdate(
  updates: ScenarioUpdate[] | undefined,
  update: ScenarioUpdate,
): ScenarioUpdate[] {
  const existing = updates ?? [];
  const index = existing.findIndex(u => u.scenarioId === update.scenarioId);
  if (index === -1) return [...existing, update];

  const priority = (u: ScenarioUpdate) => PHASE_PRIORITY[u.phase] ?? 0;
  if (priority(update) <= priority(existing[index])) return existing;
  return existing.map((u, i) => (i === index ? update : u));
}
